
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6649"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6649"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $f31a25c5e5b4b216$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["L1j1U","index.c8910e60.js","f8y3W","start-game.ea052f44.mp3","9yh7p","pacman-munch.908dda4d.mp3","7RVoc","fruit-eaten.7e0da0b9.mp3","8uDex","pacman-death.1610ead1.mp3","ezEEA","ghost-eaten.21e1a3e5.mp3","aXikI","pacman-energizer.0855a9bf.mp3"]'));

// TODO: add more robust types
const $5be4820ecee02a5a$export$85fc379452d91af0 = document.querySelector(".grid");
const $5be4820ecee02a5a$export$f752466de49ca7a4 = document.getElementById("score");
const $5be4820ecee02a5a$export$4c091633b1d4d8a8 = document.getElementById("hiscore");
const $5be4820ecee02a5a$export$4111013bfc01b0ea = document.getElementById("lives-left");
const $5be4820ecee02a5a$export$ff1e47e5e9a1860f = document.getElementById("start-screen");
const $5be4820ecee02a5a$export$ee1c394a7505fda = document.getElementById("pause-screen");
const $5be4820ecee02a5a$export$f3d32ce657fc9721 = document.getElementById("get-ready-screen");
const $5be4820ecee02a5a$export$188ce0aaed0de466 = document.getElementById("gameover-screen");
const $5be4820ecee02a5a$export$c19513be8e47ff73 = document.getElementById("start-btn");
const $5be4820ecee02a5a$export$69181d24bfc61261 = document.getElementById("reset");


var $cf7aaa54918fdfbf$exports = {};
$cf7aaa54918fdfbf$exports = new URL("start-game.ea052f44.mp3", import.meta.url).toString();


const $e4cce803ba92543b$var$startGameSoundUrl = new URL($cf7aaa54918fdfbf$exports);
const $e4cce803ba92543b$export$49d31edfd5b8d832 = new Audio($e4cce803ba92543b$var$startGameSoundUrl.href);
var $13d2784230782629$exports = {};
$13d2784230782629$exports = new URL("pacman-munch.908dda4d.mp3", import.meta.url).toString();


const $e4cce803ba92543b$var$munchSoundUrl = new URL($13d2784230782629$exports);
const $e4cce803ba92543b$export$8b6c405478dcdefa = new Audio($e4cce803ba92543b$var$munchSoundUrl.href);
var $f469b426b6472c2a$exports = {};
$f469b426b6472c2a$exports = new URL("fruit-eaten.7e0da0b9.mp3", import.meta.url).toString();


const $e4cce803ba92543b$var$fruitEatenSoundUrl = new URL($f469b426b6472c2a$exports);
const $e4cce803ba92543b$export$695f9f7631ad7ebb = new Audio($e4cce803ba92543b$var$fruitEatenSoundUrl.href);
var $1e89d6a1d65d9a00$exports = {};
$1e89d6a1d65d9a00$exports = new URL("pacman-death.1610ead1.mp3", import.meta.url).toString();


const $e4cce803ba92543b$var$deathSoundUrl = new URL($1e89d6a1d65d9a00$exports);
const $e4cce803ba92543b$export$6fe8fe1b71125e4d = new Audio($e4cce803ba92543b$var$deathSoundUrl.href);
var $f19d5610a0028748$exports = {};
$f19d5610a0028748$exports = new URL("ghost-eaten.21e1a3e5.mp3", import.meta.url).toString();


const $e4cce803ba92543b$var$ghostEatenSoundUrl = new URL($f19d5610a0028748$exports);
const $e4cce803ba92543b$export$4bce07c75c05b8a9 = new Audio($e4cce803ba92543b$var$ghostEatenSoundUrl.href);
var $660c0ba6156557bc$exports = {};
$660c0ba6156557bc$exports = new URL("pacman-energizer.0855a9bf.mp3", import.meta.url).toString();


const $e4cce803ba92543b$var$powerPillSoundUrl = new URL($660c0ba6156557bc$exports);
const $e4cce803ba92543b$export$8b17d56baf529a86 = new Audio($e4cce803ba92543b$var$powerPillSoundUrl.href);
const $e4cce803ba92543b$export$afe99aec3e2fd100 = ()=>{
    $e4cce803ba92543b$export$8b17d56baf529a86.pause();
    $e4cce803ba92543b$export$8b17d56baf529a86.currentTime = 0;
};



const $ccef23a82b4ea8b3$export$8e0a0ba3810e6397 = '<i class="fas fa-play"></i>';
const $ccef23a82b4ea8b3$export$adcaf896a7be650b = '<i class="fas fa-pause"></i>';
const $ccef23a82b4ea8b3$export$7cf12522e6965a5e = '<div class="pacman-top"></div><div class="pacman-bottom"></div>';
const $ccef23a82b4ea8b3$export$7e3df82ee760448c = 28;
const $ccef23a82b4ea8b3$export$ac607276a8fe9f0a = 31;
const $ccef23a82b4ea8b3$export$2dbb537798a02076 = 658;
const $ccef23a82b4ea8b3$export$16ca203b0955bb03 = [
    -$ccef23a82b4ea8b3$export$7e3df82ee760448c,
    -1,
    $ccef23a82b4ea8b3$export$7e3df82ee760448c,
    1
] // up, left, down, right
;
const $ccef23a82b4ea8b3$export$ccd3f75e3fb23481 = 115;
const $ccef23a82b4ea8b3$export$a95fb13041391ae3 = $ccef23a82b4ea8b3$export$ccd3f75e3fb23481 / 0.8;
const $ccef23a82b4ea8b3$export$18540bb3f387e740 = $ccef23a82b4ea8b3$export$ccd3f75e3fb23481 / 0.9;
const $ccef23a82b4ea8b3$export$2f7c5f95e8966a1f = $ccef23a82b4ea8b3$export$ccd3f75e3fb23481 / 0.75;
const $ccef23a82b4ea8b3$export$a7c72889a5ad6926 = $ccef23a82b4ea8b3$export$ccd3f75e3fb23481 / 0.5;



const $2748c9fefe0097b2$var$createGhost = ({ className: className, startIndex: startIndex, respawnIndex: respawnIndex, startTimer: startTimer, speed: speed, currentDirection: currentDirection, scatterTarget: scatterTarget })=>{
    return {
        className: className,
        startIndex: startIndex,
        respawnIndex: respawnIndex,
        startTimer: startTimer,
        speed: speed,
        currentDirection: currentDirection,
        scatterTarget: scatterTarget,
        currentIndex: startIndex,
        targetTile: 0,
        nextDirection: 0,
        isFrightened: false,
        isFlashing: false,
        firstMoveAfterFrightened: false,
        timerId: NaN,
        frightenedTimer: NaN,
        flashTimerId: NaN
    };
};
const $2748c9fefe0097b2$export$b8a5f7b241d9d5b1 = (width)=>{
    return [
        $2748c9fefe0097b2$var$createGhost({
            className: "blinky",
            startIndex: 321,
            respawnIndex: 377,
            startTimer: 0,
            speed: (0, $ccef23a82b4ea8b3$export$2f7c5f95e8966a1f),
            currentDirection: -1,
            scatterTarget: -1
        }),
        $2748c9fefe0097b2$var$createGhost({
            className: "pinky",
            startIndex: 378,
            respawnIndex: 378,
            startTimer: 5,
            speed: (0, $ccef23a82b4ea8b3$export$2f7c5f95e8966a1f),
            currentDirection: -width,
            scatterTarget: -28
        }),
        $2748c9fefe0097b2$var$createGhost({
            className: "inky",
            startIndex: 376,
            respawnIndex: 376,
            startTimer: 30,
            speed: (0, $ccef23a82b4ea8b3$export$2f7c5f95e8966a1f),
            currentDirection: 1,
            scatterTarget: 895
        }),
        $2748c9fefe0097b2$var$createGhost({
            className: "clyde",
            startIndex: 379,
            respawnIndex: 379,
            startTimer: 90,
            speed: (0, $ccef23a82b4ea8b3$export$2f7c5f95e8966a1f),
            currentDirection: -1,
            scatterTarget: 868
        })
    ];
// return [new Ghost('clyde', 379, 379, 0, 500, -1, 868)]
// return [new Ghost('blinky', 321, 377, 0, 1000, -1, -1)]
// return [new Ghost('blinky', 394, 377, 0, 1000, -1, -1)]
// return [new Ghost('blinky', 417, 377, 0, 1000, 1, -1)]
};
const $2748c9fefe0097b2$export$4a6889fd0ca293a4 = (state)=>{
    state.ghosts.forEach((ghost)=>{
        state.squares[ghost.currentIndex].classList.add(ghost.className);
        state.squares[ghost.currentIndex].classList.add("ghost");
    });
};




const $54c27ffebbfab1ae$var$addWallborders = (state)=>{
    state.squares.forEach((square, i, arr)=>{
        // checking for wall exterior sides
        const isAtTopEdge = i - (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) < 0;
        const isAtRightEdge = i % (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) === (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) - 1;
        const isAtBottomEdge = i + (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) >= (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) * (0, $ccef23a82b4ea8b3$export$ac607276a8fe9f0a);
        const isAtLeftEdge = i % (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) === 0;
        // check for wall internal sides
        const isTopSide = i - (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) > 28 && !arr[i - (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c)].classList.contains("wall");
        const isRightSide = i + 1 < 867 && !arr[i + 1].classList.contains("wall");
        const isBottomSide = i + (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) < (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) * 30 && !arr[i + (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c)].classList.contains("wall");
        const isLeftSide = i - 1 > 0 && !arr[i - 1].classList.contains("wall");
        // add wall border classes
        if (square.classList.contains("wall")) {
            if (isAtTopEdge || isTopSide) square.classList.add("border-top");
            if (isAtRightEdge || isRightSide) square.classList.add("border-right");
            if (isAtBottomEdge || isBottomSide) square.classList.add("border-bottom");
            if (isAtLeftEdge || isLeftSide) square.classList.add("border-left");
        }
    });
};
const $54c27ffebbfab1ae$var$updateLivesDisplay = (state)=>{
    (0, $5be4820ecee02a5a$export$4111013bfc01b0ea).innerHTML = "";
    for(let i = 0; i < state.livesLeft; i++){
        const live = document.createElement("div");
        live.classList.add("life");
        live.innerHTML = (0, $ccef23a82b4ea8b3$export$7cf12522e6965a5e);
        (0, $5be4820ecee02a5a$export$4111013bfc01b0ea).appendChild(live);
    }
};
const $54c27ffebbfab1ae$export$c1c6fc7b5402fc3c = (state)=>{
    $54c27ffebbfab1ae$var$addWallborders(state);
    $54c27ffebbfab1ae$var$updateLivesDisplay(state);
};







const $cd59ff918bd3410b$export$5eefcab301b81d70 = (state)=>{
    (0, $5be4820ecee02a5a$export$4111013bfc01b0ea).innerHTML = "";
    for(let i = 0; i < state.livesLeft; i++){
        const live = document.createElement("div");
        live.classList.add("life");
        live.innerHTML = (0, $ccef23a82b4ea8b3$export$7cf12522e6965a5e);
        (0, $5be4820ecee02a5a$export$4111013bfc01b0ea).appendChild(live);
    }
};




const $b24d41a60d22afcf$export$482310739c8f9d71 = (state)=>{
    (0, $5be4820ecee02a5a$export$f752466de49ca7a4).textContent = state.score.toString();
};
const $b24d41a60d22afcf$export$7acfb7dba2e12414 = (state)=>{
    if (localStorage.pacmanHiscore) {
        state.hiscore = localStorage.pacmanHiscore;
        (0, $5be4820ecee02a5a$export$4c091633b1d4d8a8).textContent = state.hiscore.toString();
    }
};
const $b24d41a60d22afcf$export$42ad8a4a4f0c66d3 = (state)=>{
    if (state.score > state.hiscore) {
        state.hiscore = state.score;
        (0, $5be4820ecee02a5a$export$4c091633b1d4d8a8).textContent = state.hiscore.toString();
        localStorage.setItem("pacmanHiscore", state.hiscore.toString());
    }
};
const $b24d41a60d22afcf$export$431bb712769a2636 = (state)=>{
    state.score += state.ghostsEatenPoints;
    state.ghostsEatenPoints *= 2;
};



const $5230a55153f85212$var$gameOver = (state)=>{
    state.isGameOver = true;
    (0, $5be4820ecee02a5a$export$188ce0aaed0de466).style.display = "block";
    (0, $b24d41a60d22afcf$export$42ad8a4a4f0c66d3)(state);
    state.gameoverTimer = setTimeout(()=>(0, $4fc77922838a58e3$export$8a9e2a13fbf8faaf)(state), 2000);
};
const $5230a55153f85212$var$removeLife = (state)=>{
    (0, $e4cce803ba92543b$export$6fe8fe1b71125e4d).play();
    (0, $e4cce803ba92543b$export$afe99aec3e2fd100)();
    if (state.livesLeft === 0) $5230a55153f85212$var$gameOver(state);
    else {
        state.livesLeft--;
        (0, $cd59ff918bd3410b$export$5eefcab301b81d70)(state);
        (0, $4fc77922838a58e3$export$1b2871a969452732)(state);
    }
};
const $5230a55153f85212$export$e428d9c3687727ad = (state, ghost)=>{
    state.squares[ghost.currentIndex].classList.remove(ghost.className, "ghost", "frightened-ghost", "frightened-ghost-flash");
};
const $5230a55153f85212$export$c4d663b3179f61e3 = (state)=>{
    state.ghosts.forEach((ghost)=>{
        clearInterval(ghost.timerId);
        (0, $b4a59dc4f54325d3$export$d4941d5504e4386c)(state, ghost);
        $5230a55153f85212$export$e428d9c3687727ad(state, ghost);
    });
};
const $5230a55153f85212$export$50ef05eaf70c9e3f = (state, pacmanCurrentTile)=>{
    pacmanCurrentTile.classList.remove("pacman", state.pacmanMovementClass);
    pacmanCurrentTile.innerHTML = "";
};
const $5230a55153f85212$export$b5d444d2c2d00782 = (state)=>{
    const pacmanCurrentTile = state.squares[state.pacmanCurrentIndex];
    const didGhostGetPacman = pacmanCurrentTile.classList.contains("ghost");
    const isGhostFrightened = pacmanCurrentTile.classList.contains("frightened-ghost");
    if (didGhostGetPacman && !isGhostFrightened) {
        clearInterval(state.pacmanTimerId);
        $5230a55153f85212$var$removeLife(state);
        $5230a55153f85212$export$c4d663b3179f61e3(state);
        $5230a55153f85212$export$50ef05eaf70c9e3f(state, pacmanCurrentTile);
        state.isPaused = true;
        state.ghostsEatenPoints = 200;
    }
};


const $4686cf16043442f5$export$c87e8f7040a9ec4 = (tileIndex)=>{
    // find the X,Y coordinates of a given index
    const coordY = Math.floor(tileIndex / 28);
    const coordX = tileIndex - coordY * 28;
    return [
        coordX,
        coordY
    ];
};
const $4686cf16043442f5$export$2723c3144172fb52 = (point1XY, point2XY)=>{
    return Math.sqrt((point1XY[0] - point2XY[0]) ** 2 + (point1XY[1] - point2XY[1]) ** 2);
};
const $4686cf16043442f5$export$49906ab802ee8b16 = (legalDirections, nextTile, ghost)=>{
    const shortestDistance = legalDirections.map((direction)=>{
        const optionTileIndex = nextTile + direction;
        const optionXY = $4686cf16043442f5$export$c87e8f7040a9ec4(optionTileIndex);
        const targetXY = $4686cf16043442f5$export$c87e8f7040a9ec4(ghost.targetTile);
        const distance = $4686cf16043442f5$export$2723c3144172fb52(optionXY, targetXY);
        return {
            direction: direction,
            distance: distance
        };
    });
    shortestDistance.sort((a, b)=>{
        return a.distance - b.distance;
    });
    // console.log(shortestDistance)
    return shortestDistance[0].direction;
};




const $f51cbeb564f69c4e$var$getBlinkysTarget = (state)=>{
    // Blinky's target is Pacman's current tile
    return state.pacmanCurrentIndex;
};
const $f51cbeb564f69c4e$var$getPinkysTarget = (state)=>{
    // Pinky's target is 4 ahead of Pacman's current tile
    const pacmanXY = (0, $4686cf16043442f5$export$c87e8f7040a9ec4)(state.pacmanCurrentIndex);
    // grid is 1D, so we need to prevent the target wrapping to other side of the grid!!!
    if (state.pacmanCurrentDirection === 1 && pacmanXY[0] > 23) return pacmanXY[1] * (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) + ((0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) - 1);
    if (state.pacmanCurrentDirection === -1 && pacmanXY[0] < 3) return pacmanXY[1] * (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c);
    const fourTileOffset = 4 * state.pacmanCurrentDirection;
    return state.pacmanCurrentIndex + fourTileOffset;
};
const $f51cbeb564f69c4e$var$getInkysTarget = (state)=>{
    // inky has the most complex targeting scheme!!!
    // we find 2 tile offset from pacman's heading and draw a line from blinky's position
    // we then double the distance and continue past the offset in the same direction
    // find X,Y for 2 tile offset from pacman's heading
    const twoTileOffset = 2 * state.pacmanCurrentDirection + state.pacmanCurrentIndex;
    const offsetXY = (0, $4686cf16043442f5$export$c87e8f7040a9ec4)(twoTileOffset);
    // find X,Y for Blinky
    const blinkyXY = (0, $4686cf16043442f5$export$c87e8f7040a9ec4)(state.ghosts[0].currentIndex);
    const differenceX = offsetXY[0] - blinkyXY[0];
    const differenceY = offsetXY[1] - blinkyXY[1];
    let targetTileX = offsetXY[0] + differenceX;
    const targetTileY = offsetXY[1] + differenceY;
    // grid is 1D, so we need to prevent the target wrapping to other side of the grid!!!
    if (targetTileX > 27) targetTileX = 27;
    else if (targetTileX < 0) targetTileX = 0;
    const targetTileIndex = targetTileY * (0, $ccef23a82b4ea8b3$export$7e3df82ee760448c) + targetTileX;
    return targetTileIndex;
};
const $f51cbeb564f69c4e$var$getClydesTarget = (state, clyde)=>{
    const pacmanXY = (0, $4686cf16043442f5$export$c87e8f7040a9ec4)(state.pacmanCurrentIndex);
    const clydeXY = (0, $4686cf16043442f5$export$c87e8f7040a9ec4)(clyde.currentIndex);
    const distance = (0, $4686cf16043442f5$export$2723c3144172fb52)(pacmanXY, clydeXY);
    if (distance > 8) // if clyde is > 8 tiles from pacman, his targetTile is pacman
    return state.pacmanCurrentIndex;
    else // if clyde is < 8 tiles from pacman, he uses his scatter target
    return clyde.scatterTarget;
};
const $f51cbeb564f69c4e$export$563a3adf67629912 = (state, ghost)=>{
    // if in ghost lair, set targetTile manually
    if (state.squares[ghost.currentIndex].classList.contains("ghost-lair")) ghost.targetTile = 321;
    else {
        // else we use specific logic routines to calculate
        if (ghost.className === "blinky") ghost.targetTile = $f51cbeb564f69c4e$var$getBlinkysTarget(state);
        if (ghost.className === "pinky") ghost.targetTile = $f51cbeb564f69c4e$var$getPinkysTarget(state);
        if (ghost.className === "inky") ghost.targetTile = $f51cbeb564f69c4e$var$getInkysTarget(state);
        if (ghost.className === "clyde") ghost.targetTile = $f51cbeb564f69c4e$var$getClydesTarget(state, ghost);
    }
};


const $b4a59dc4f54325d3$var$isGhostFrightened = (state, ghost)=>{
    if (ghost.isFrightened) state.squares[ghost.currentIndex].classList.add("frightened-ghost");
    if (ghost.isFlashing) state.squares[ghost.currentIndex].classList.add("frightened-ghost-flash");
};
const $b4a59dc4f54325d3$var$isDirectionLegal = (state, tileIndex)=>{
    return !state.squares[tileIndex].classList.contains("wall") && !state.squares[tileIndex].classList.contains("ghost-lair");
};
const $b4a59dc4f54325d3$var$getRandomDirection = (state, ghost)=>{
    // if randomDirection not legal, ghost chooses next legal direction in order of up, left, down, right (same as order in ghostDirections arr)
    const randomIndex = Math.floor(Math.random() * (0, $ccef23a82b4ea8b3$export$16ca203b0955bb03).length);
    const randomDirection = (0, $ccef23a82b4ea8b3$export$16ca203b0955bb03)[randomIndex];
    const isNotReverseDirection = randomDirection !== -ghost.currentDirection;
    const nextTile = ghost.currentIndex + ghost.currentDirection;
    const directionOption = randomDirection + nextTile;
    if ($b4a59dc4f54325d3$var$isDirectionLegal(state, directionOption) && isNotReverseDirection) return randomDirection;
    const remainingDirections = (0, $ccef23a82b4ea8b3$export$16ca203b0955bb03).filter((direction)=>{
        const directionOption = direction + nextTile;
        if (direction === randomDirection) return false;
        if (direction === -ghost.currentDirection) return false;
        return $b4a59dc4f54325d3$var$isDirectionLegal(state, directionOption);
    });
    return remainingDirections[0];
};
const $b4a59dc4f54325d3$var$firstDirectionAfterFrightened = (state, ghost)=>{
    const reverseTile = ghost.currentIndex + -ghost.currentDirection;
    ghost.firstMoveAfterFrightened = false;
    if ($b4a59dc4f54325d3$var$isDirectionLegal(state, reverseTile)) return -ghost.currentDirection;
    else return $b4a59dc4f54325d3$var$getRandomDirection(state, ghost);
};
const $b4a59dc4f54325d3$var$getFrightenedGhostDirection = (state, ghost)=>{
    // after first becoming frightened, ghost will attempt to reverse direction (if legal)
    // otherwise we choose a random direction
    if (ghost.firstMoveAfterFrightened) return $b4a59dc4f54325d3$var$firstDirectionAfterFrightened(state, ghost);
    else return $b4a59dc4f54325d3$var$getRandomDirection(state, ghost);
};
const $b4a59dc4f54325d3$var$getLegalGhostDirections = (state, nextTile, ghost)=>{
    return (0, $ccef23a82b4ea8b3$export$16ca203b0955bb03).filter((direction)=>{
        const tileIndex = nextTile + direction;
        if (direction === -ghost.currentDirection) return false;
        if (state.squares[ghost.currentIndex].classList.contains("ghost-lair") && state.squares[tileIndex].classList.contains("ghost-lair")) return true;
        return $b4a59dc4f54325d3$var$isDirectionLegal(state, tileIndex);
    });
};
const $b4a59dc4f54325d3$var$getNextGhostDirection = (state, ghost)=>{
    // ghost plans movement one tile ahead, so we check nextTile for legal direction options
    // cannot reverse direction, return to lair, or move into wall
    const nextTile = ghost.currentIndex + ghost.currentDirection;
    // console.log('currentIndex = ' + ghost.currentIndex)
    // console.log('currentDirection = ' + ghost.currentDirection)
    // console.log('nextTile = ' + nextTile)
    // if (nextTile === 392) {
    //   ghost.nextDirection = -1
    // } else if (nextTile === 419) {
    //   ghost.nextDirection = 1
    // } else {
    const legalDirections = $b4a59dc4f54325d3$var$getLegalGhostDirections(state, nextTile, ghost);
    if (legalDirections.length > 1) return (0, $4686cf16043442f5$export$49906ab802ee8b16)(legalDirections, nextTile, ghost);
    else return legalDirections[0];
// }
};
const $b4a59dc4f54325d3$var$moveGhost = (state, ghost)=>{
    if (ghost.isFrightened) ghost.nextDirection = $b4a59dc4f54325d3$var$getFrightenedGhostDirection(state, ghost);
    else {
        (0, $f51cbeb564f69c4e$export$563a3adf67629912)(state, ghost);
        ghost.nextDirection = $b4a59dc4f54325d3$var$getNextGhostDirection(state, ghost);
    }
    state.squares[ghost.currentIndex].classList.remove(ghost.className);
    state.squares[ghost.currentIndex].classList.remove("ghost", "frightened-ghost", "frightened-ghost-flash");
    ghost.currentIndex += ghost.currentDirection;
    //  override for ghost tunnel movement
    if (ghost.currentIndex === 392) {
        ghost.currentIndex = 419;
        ghost.nextDirection = -1;
    } else if (ghost.currentIndex === 419) {
        ghost.currentIndex = 392;
        ghost.nextDirection = 1;
    }
    state.squares[ghost.currentIndex].classList.add(ghost.className);
    state.squares[ghost.currentIndex].classList.add("ghost");
    ghost.currentDirection = ghost.nextDirection;
};
const $b4a59dc4f54325d3$export$aa74fcc737182d77 = (state, ghost)=>{
    console.log("initGhostMovement", ghost.isFrightened);
    clearInterval(ghost.timerId);
    ghost.timerId = setInterval(()=>{
        // each ghost has dotsEaten threshold for leaving lair
        if (state.dotsEaten >= ghost.startTimer) {
            $b4a59dc4f54325d3$var$moveGhost(state, ghost);
            $b4a59dc4f54325d3$var$isGhostFrightened(state, ghost);
            // checkForGameOver()
            (0, $5230a55153f85212$export$b5d444d2c2d00782)(state);
        }
    }, ghost.speed);
};
const $b4a59dc4f54325d3$export$d4941d5504e4386c = (state, ghost)=>{
    // so that eating second pill while ghosts frightened resets timer
    clearTimeout(ghost.frightenedTimer);
    clearTimeout(ghost.flashTimerId);
    state.squares[ghost.currentIndex].classList.remove("frightened-ghost-flash");
    ghost.isFlashing = false;
};





const $e804251215e8434e$var$w = "wall";
const $e804251215e8434e$var$b = "blank";
const $e804251215e8434e$var$d = "pac-dot";
const $e804251215e8434e$var$p = "power-pill";
const $e804251215e8434e$var$l = "ghost-lair";
const $e804251215e8434e$var$e = "door";
const $e804251215e8434e$var$x = "invisible-wall";
const $e804251215e8434e$var$f = "bonus-sq";
const $e804251215e8434e$export$b3219800bda33a1f = [
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$p,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$p,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$e,
    $e804251215e8434e$var$e,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$l,
    $e804251215e8434e$var$l,
    $e804251215e8434e$var$l,
    $e804251215e8434e$var$l,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$x,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$f,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$p,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$b,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$p,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$d,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w,
    $e804251215e8434e$var$w
];


const $283d2e7faaab6e1a$export$f564834a4834aaa5 = ()=>{
    return (0, $e804251215e8434e$export$b3219800bda33a1f).map((cell)=>{
        const square = document.createElement("div");
        (0, $5be4820ecee02a5a$export$85fc379452d91af0).appendChild(square);
        square.classList.add("cell", cell);
        if (cell === "door") square.classList.add("ghost-lair");
        if (cell === "bonus-sq") square.classList.add("blank");
        return square;
    });
};
const $283d2e7faaab6e1a$export$3ee49b4c70c0ec29 = ()=>{
    return {
        squares: $283d2e7faaab6e1a$export$f564834a4834aaa5(),
        score: 0,
        hiscore: 0,
        livesLeft: 2,
        pacmanCurrentIndex: 658,
        pacmanCurrentDirection: 1,
        pacmanMovementClass: "pacman-facing-right",
        dotsEaten: 0,
        ghostsEatenPoints: 200,
        firstBonusRemoved: false,
        secondBonusRemoved: false,
        isPaused: true,
        isGameOver: true,
        ghosts: (0, $2748c9fefe0097b2$export$b8a5f7b241d9d5b1)((0, $ccef23a82b4ea8b3$export$7e3df82ee760448c)),
        getReadyTimer: NaN,
        gameoverTimer: NaN,
        pacmanTimerId: NaN
    };
};









const $2af5fa0b02f232dd$var$resetGhostTimers = (state, ghost)=>{
    // so that eating second pill while ghosts frightened resets timer
    clearTimeout(ghost.frightenedTimer);
    clearTimeout(ghost.flashTimerId);
    state.squares[ghost.currentIndex].classList.remove("frightened-ghost-flash");
    ghost.isFlashing = false;
};
const $2af5fa0b02f232dd$var$makeGhostFlash = (state, ghost)=>{
    if (ghost.isFrightened) {
        ghost.isFlashing = true;
        state.squares[ghost.currentIndex].classList.add("frightened-ghost-flash");
    }
};
const $2af5fa0b02f232dd$export$844f15ad33230310 = (state)=>{
    state.ghosts.forEach((ghost)=>{
        $2af5fa0b02f232dd$var$resetGhostTimers(state, ghost);
        if (!state.squares[ghost.currentIndex].classList.contains("ghost-lair")) {
            ghost.isFrightened = true;
            ghost.firstMoveAfterFrightened = true;
            state.squares[ghost.currentIndex].classList.add("frightened-ghost");
            ghost.flashTimerId = setTimeout(()=>$2af5fa0b02f232dd$var$makeGhostFlash(state, ghost), 7000);
            ghost.frightenedTimer = setTimeout(()=>$2af5fa0b02f232dd$var$unFrightenGhosts(state), 10000);
            ghost.speed = (0, $ccef23a82b4ea8b3$export$a7c72889a5ad6926);
            (0, $b4a59dc4f54325d3$export$aa74fcc737182d77)(state, ghost);
        }
    });
};
const $2af5fa0b02f232dd$var$unFrightenGhosts = (state)=>{
    state.ghosts.forEach((ghost)=>{
        ghost.isFrightened = false;
        ghost.isFlashing = false;
        ghost.speed = (0, $ccef23a82b4ea8b3$export$2f7c5f95e8966a1f);
        (0, $b4a59dc4f54325d3$export$aa74fcc737182d77)(state, ghost);
    });
    state.ghostsEatenPoints = 200;
};
const $2af5fa0b02f232dd$export$de15c5427f84c105 = (state, pacmanCurrentSquare)=>{
    if (pacmanCurrentSquare.classList.contains("blinky")) return state.ghosts[0];
    if (pacmanCurrentSquare.classList.contains("pinky")) return state.ghosts[1];
    if (pacmanCurrentSquare.classList.contains("inky")) return state.ghosts[2];
    return state.ghosts[3] // if (pacmanCurrentSquare.classList.contains('clyde'))
    ;
};
const $2af5fa0b02f232dd$export$1515b95269129150 = (state, ghost)=>{
    (0, $5230a55153f85212$export$e428d9c3687727ad)(state, ghost);
    $2af5fa0b02f232dd$var$resetGhostTimers(state, ghost);
    // change ghosts currentIndex back to its startIndex
    ghost.isFrightened = false;
    ghost.currentIndex = ghost.respawnIndex;
    ghost.currentDirection = -(0, $ccef23a82b4ea8b3$export$7e3df82ee760448c);
    // state.score += 200
    (0, $b24d41a60d22afcf$export$431bb712769a2636)(state);
    (0, $b24d41a60d22afcf$export$482310739c8f9d71)(state);
    // re-add classnames of ghost.className and 'ghost' to the ghosts new postion
    state.squares[ghost.currentIndex].classList.add(ghost.className, "ghost");
};








const $54c37b261f658168$export$847186a44dad0185 = (state)=>{
    // default is >243
    if (state.dotsEaten > 243) {
        (0, $e4cce803ba92543b$export$afe99aec3e2fd100)();
        $54c37b261f658168$var$startNextLevel(state);
    }
};
const $54c37b261f658168$var$startNextLevel = (state)=>{
    state.isPaused = true;
    state.dotsEaten = 0;
    state.ghostsEatenPoints = 200;
    state.firstBonusRemoved = false;
    state.secondBonusRemoved = false;
    (0, $5230a55153f85212$export$c4d663b3179f61e3)(state);
    const pacmanCurrentTile = state.squares[state.pacmanCurrentIndex];
    (0, $5230a55153f85212$export$50ef05eaf70c9e3f)(state, pacmanCurrentTile);
    (0, $5be4820ecee02a5a$export$85fc379452d91af0).innerHTML = "";
    state.squares = (0, $283d2e7faaab6e1a$export$f564834a4834aaa5)();
    (0, $54c27ffebbfab1ae$export$c1c6fc7b5402fc3c)(state);
    (0, $4fc77922838a58e3$export$1b2871a969452732)(state);
};



const $5afcfcf639367f44$export$7928d5a5e365fe26 = (state)=>{
    state.pacmanCurrentIndex = (0, $ccef23a82b4ea8b3$export$2dbb537798a02076);
    state.pacmanMovementClass = "pacman-facing-right";
    state.squares[state.pacmanCurrentIndex].classList.add("pacman", state.pacmanMovementClass);
    state.squares[state.pacmanCurrentIndex].innerHTML = (0, $ccef23a82b4ea8b3$export$7cf12522e6965a5e);
};
const $5afcfcf639367f44$var$removePacman = (pacmanCurrentTile, state)=>{
    pacmanCurrentTile.classList.remove("pacman", state.pacmanMovementClass);
    pacmanCurrentTile.innerHTML = "";
};
const $5afcfcf639367f44$var$didPacmanEatDot = (state)=>{
    if (state.squares[state.pacmanCurrentIndex].classList.contains("pac-dot")) {
        state.squares[state.pacmanCurrentIndex].classList.remove("pac-dot");
        state.squares[state.pacmanCurrentIndex].classList.add("blank");
        state.dotsEaten++;
        state.score += 10;
        (0, $b24d41a60d22afcf$export$482310739c8f9d71)(state);
        (0, $e4cce803ba92543b$export$8b6c405478dcdefa).play();
    }
};
const $5afcfcf639367f44$var$didPacmanEatPowerPill = (state)=>{
    if (state.squares[state.pacmanCurrentIndex].classList.contains("power-pill")) {
        state.squares[state.pacmanCurrentIndex].classList.remove("power-pill");
        state.squares[state.pacmanCurrentIndex].classList.add("blank");
        state.score += 50;
        state.dotsEaten++;
        state.ghostsEatenPoints = 200;
        (0, $e4cce803ba92543b$export$8b17d56baf529a86).currentTime = 0;
        (0, $e4cce803ba92543b$export$8b17d56baf529a86).play();
        (0, $b24d41a60d22afcf$export$482310739c8f9d71)(state);
        (0, $2af5fa0b02f232dd$export$844f15ad33230310)(state);
    }
};
const $5afcfcf639367f44$var$addBonusToBoard = (state)=>{
    if (state.dotsEaten === 70 && !state.firstBonusRemoved) {
        state.squares[490].classList.add("bonus-cherry");
        setTimeout(()=>$5afcfcf639367f44$var$removeFirstCherry(state), 10000);
    }
    if (state.dotsEaten === 170 && !state.secondBonusRemoved) {
        state.squares[490].classList.add("bonus-cherry");
        setTimeout(()=>$5afcfcf639367f44$var$removeSecondCherry(state), 10000);
    }
};
const $5afcfcf639367f44$var$removeFirstCherry = (state)=>{
    state.squares[490].classList.remove("bonus-cherry");
    state.firstBonusRemoved = true;
};
const $5afcfcf639367f44$var$removeSecondCherry = (state)=>{
    state.squares[490].classList.remove("bonus-cherry");
    state.secondBonusRemoved = true;
};
const $5afcfcf639367f44$var$didPacmanEatBonus = (state)=>{
    if (state.squares[state.pacmanCurrentIndex].classList.contains("bonus-cherry")) {
        state.squares[state.pacmanCurrentIndex].classList.remove("bonus-cherry");
        state.score += 100;
        (0, $b24d41a60d22afcf$export$482310739c8f9d71)(state);
        (0, $e4cce803ba92543b$export$695f9f7631ad7ebb).play();
        if (!state.firstBonusRemoved) state.firstBonusRemoved = true;
        else if (!state.secondBonusRemoved) state.secondBonusRemoved = true;
    }
};
const $5afcfcf639367f44$var$didPacmanEatGhost = (state)=>{
    const pacmanCurrentSquare = state.squares[state.pacmanCurrentIndex];
    if (pacmanCurrentSquare.classList.contains("frightened-ghost")) {
        const ghost = (0, $2af5fa0b02f232dd$export$de15c5427f84c105)(state, pacmanCurrentSquare);
        (0, $2af5fa0b02f232dd$export$1515b95269129150)(state, ghost);
        (0, $e4cce803ba92543b$export$4bce07c75c05b8a9).play();
    }
};
const $5afcfcf639367f44$var$getRequestedDirection = (state, input)=>{
    switch(input){
        case "ArrowDown":
        case "down":
        case "s":
            return 0, $ccef23a82b4ea8b3$export$7e3df82ee760448c;
        case "ArrowUp":
        case "up":
        case "w":
            return -(0, $ccef23a82b4ea8b3$export$7e3df82ee760448c);
        case "ArrowLeft":
        case "left":
        case "a":
            return -1;
        case "ArrowRight":
        case "right":
        case "d":
            return 1;
        default:
            return state.pacmanCurrentDirection;
    }
};
const $5afcfcf639367f44$var$checkForWall = (state, requestedIndex)=>{
    return state.squares[requestedIndex].classList.contains("wall") || state.squares[requestedIndex].classList.contains("ghost-lair");
};
const $5afcfcf639367f44$var$movePacman = (state, direction)=>{
    if (state.isPaused) return;
    const requestedIndex = state.pacmanCurrentIndex + direction;
    if ($5afcfcf639367f44$var$checkForWall(state, requestedIndex)) return;
    /**
   * check before and after pacman moves to see if he ate a frightened ghost
   */ $5afcfcf639367f44$var$didPacmanEatGhost(state);
    const pacmanCurrentTile = state.squares[state.pacmanCurrentIndex];
    $5afcfcf639367f44$var$removePacman(pacmanCurrentTile, state);
    state.pacmanCurrentIndex = requestedIndex;
    state.pacmanCurrentDirection = direction;
    switch(direction){
        case 1:
            state.pacmanMovementClass = "pacman-facing-right";
            break;
        case -1:
            state.pacmanMovementClass = "pacman-facing-left";
            break;
        case 28:
            state.pacmanMovementClass = "pacman-facing-down";
            break;
        case -28:
            state.pacmanMovementClass = "pacman-facing-up";
            break;
    }
    if (state.pacmanCurrentIndex === 392) state.pacmanCurrentIndex = 419;
    else if (state.pacmanCurrentIndex === 419) state.pacmanCurrentIndex = 392;
    state.squares[state.pacmanCurrentIndex].classList.add("pacman", state.pacmanMovementClass);
    state.squares[state.pacmanCurrentIndex].innerHTML = (0, $ccef23a82b4ea8b3$export$7cf12522e6965a5e);
    $5afcfcf639367f44$var$didPacmanEatGhost(state);
    $5afcfcf639367f44$var$didPacmanEatDot(state);
    $5afcfcf639367f44$var$didPacmanEatPowerPill(state);
    $5afcfcf639367f44$var$addBonusToBoard(state);
    $5afcfcf639367f44$var$didPacmanEatBonus(state);
    (0, $54c37b261f658168$export$847186a44dad0185)(state);
    (0, $5230a55153f85212$export$b5d444d2c2d00782)(state);
};
const $5afcfcf639367f44$export$cfc9526388d5e621 = (event, state)=>{
    const input = event.type === "keydown" ? event.key : event.currentTarget?.id;
    const requestedDirection = $5afcfcf639367f44$var$getRequestedDirection(state, input);
    const requestedIndex = state.pacmanCurrentIndex + requestedDirection;
    if ($5afcfcf639367f44$var$checkForWall(state, requestedIndex)) return;
    // prevent spamming of movement keys to speed up pacman
    if (requestedDirection === state.pacmanCurrentDirection) return;
    clearInterval(state.pacmanTimerId);
    $5afcfcf639367f44$var$movePacman(state, requestedDirection);
    state.pacmanTimerId = setInterval(()=>$5afcfcf639367f44$var$movePacman(state, requestedDirection), (0, $ccef23a82b4ea8b3$export$a95fb13041391ae3));
};



const $4fc77922838a58e3$var$resumeGame = (state)=>{
    state.isPaused = false;
    (0, $5be4820ecee02a5a$export$c19513be8e47ff73).innerHTML = (0, $ccef23a82b4ea8b3$export$adcaf896a7be650b);
    (0, $5be4820ecee02a5a$export$ee1c394a7505fda).style.display = "none";
    state.ghosts.forEach((ghost)=>(0, $b4a59dc4f54325d3$export$aa74fcc737182d77)(state, ghost));
};
const $4fc77922838a58e3$export$1b2871a969452732 = (state)=>{
    (0, $5be4820ecee02a5a$export$ff1e47e5e9a1860f).style.display = "none";
    (0, $5be4820ecee02a5a$export$f3d32ce657fc9721).style.display = "block";
    state.getReadyTimer = setTimeout(()=>$4fc77922838a58e3$var$startGame(state), 1500);
};
const $4fc77922838a58e3$var$pauseGame = (state)=>{
    state.isPaused = true;
    (0, $5be4820ecee02a5a$export$c19513be8e47ff73).innerHTML = (0, $ccef23a82b4ea8b3$export$8e0a0ba3810e6397);
    (0, $5be4820ecee02a5a$export$ee1c394a7505fda).style.display = "block";
    state.ghosts.forEach((ghost)=>clearInterval(ghost.timerId));
};
const $4fc77922838a58e3$export$7849d704a310c6d1 = (state)=>{
    if (state.isGameOver) {
        (0, $e4cce803ba92543b$export$49d31edfd5b8d832).play();
        $4fc77922838a58e3$export$1b2871a969452732(state);
    } else if (state.isPaused) $4fc77922838a58e3$var$resumeGame(state);
    else if (!state.isPaused) $4fc77922838a58e3$var$pauseGame(state);
};
const $4fc77922838a58e3$var$startGame = (state)=>{
    (0, $5be4820ecee02a5a$export$c19513be8e47ff73).innerHTML = (0, $ccef23a82b4ea8b3$export$adcaf896a7be650b);
    (0, $5be4820ecee02a5a$export$f3d32ce657fc9721).style.display = "none";
    (0, $5afcfcf639367f44$export$7928d5a5e365fe26)(state);
    // TODO: only need to create ghosts on new level, not on game start
    state.ghosts = (0, $2748c9fefe0097b2$export$b8a5f7b241d9d5b1)((0, $ccef23a82b4ea8b3$export$7e3df82ee760448c));
    (0, $2748c9fefe0097b2$export$4a6889fd0ca293a4)(state);
    state.ghosts.forEach((ghost)=>(0, $b4a59dc4f54325d3$export$aa74fcc737182d77)(state, ghost));
    state.isGameOver = false;
    state.isPaused = false;
    // automatically start pacman moving left
    const fakeEvent = {
        type: "keydown",
        key: "a"
    };
    (0, $5afcfcf639367f44$export$cfc9526388d5e621)(fakeEvent, state);
};
const $4fc77922838a58e3$export$8a9e2a13fbf8faaf = (state)=>{
    state.ghosts.forEach((ghost)=>{
        clearInterval(ghost.timerId);
        clearTimeout(ghost.flashTimerId);
    });
    clearInterval(state.pacmanTimerId);
    (0, $5be4820ecee02a5a$export$ff1e47e5e9a1860f).style.display = "block";
    (0, $5be4820ecee02a5a$export$ee1c394a7505fda).style.display = "none";
    (0, $5be4820ecee02a5a$export$f3d32ce657fc9721).style.display = "none";
    (0, $5be4820ecee02a5a$export$188ce0aaed0de466).style.display = "none";
    clearTimeout(state.getReadyTimer);
    clearTimeout(state.gameoverTimer);
    state.isPaused = true;
    state.isGameOver = true;
    state.score = 0;
    state.livesLeft = 2;
    state.dotsEaten = 0;
    state.ghostsEatenPoints = 200;
    state.firstBonusRemoved = false;
    state.secondBonusRemoved = false;
    (0, $5be4820ecee02a5a$export$85fc379452d91af0).innerHTML = "";
    (0, $5be4820ecee02a5a$export$c19513be8e47ff73).innerHTML = (0, $ccef23a82b4ea8b3$export$8e0a0ba3810e6397);
    state.ghosts = (0, $2748c9fefe0097b2$export$b8a5f7b241d9d5b1)((0, $ccef23a82b4ea8b3$export$7e3df82ee760448c));
    (0, $e4cce803ba92543b$export$afe99aec3e2fd100)();
    (0, $b24d41a60d22afcf$export$482310739c8f9d71)(state);
    state.squares = (0, $283d2e7faaab6e1a$export$f564834a4834aaa5)();
    (0, $54c27ffebbfab1ae$export$c1c6fc7b5402fc3c)(state);
};






const $370dc64264c1ee10$var$unlockAudioForiOS = ()=>{
    const audioToUnlock = [
        (0, $e4cce803ba92543b$export$49d31edfd5b8d832),
        (0, $e4cce803ba92543b$export$8b6c405478dcdefa),
        (0, $e4cce803ba92543b$export$695f9f7631ad7ebb),
        (0, $e4cce803ba92543b$export$6fe8fe1b71125e4d),
        (0, $e4cce803ba92543b$export$4bce07c75c05b8a9),
        (0, $e4cce803ba92543b$export$8b17d56baf529a86)
    ];
    audioToUnlock.forEach((audio)=>{
        audio.play();
        audio.pause();
        audio.currentTime = 0;
    });
    document.removeEventListener("touchstart", $370dc64264c1ee10$var$unlockAudioForiOS);
};
const $370dc64264c1ee10$export$19710ec455966cdd = ()=>{
    document.addEventListener("touchstart", $370dc64264c1ee10$var$unlockAudioForiOS);
};




const $ce2ba66ea21af99b$export$5628c3fd64086fd4 = ()=>{
    // fix for getting audio to play on iOS
    (0, $370dc64264c1ee10$export$19710ec455966cdd)();
    const state = (0, $283d2e7faaab6e1a$export$3ee49b4c70c0ec29)();
    (0, $54c27ffebbfab1ae$export$c1c6fc7b5402fc3c)(state);
    (0, $b24d41a60d22afcf$export$7acfb7dba2e12414)(state);
    (0, $cd59ff918bd3410b$export$5eefcab301b81d70)(state);
    (0, $5afcfcf639367f44$export$7928d5a5e365fe26)(state);
    return state;
};



const $d18313a77770ed23$var$state = (0, $ce2ba66ea21af99b$export$5628c3fd64086fd4)();
document.addEventListener("keydown", (e)=>{
    if ($d18313a77770ed23$var$state.isPaused) return;
    (0, $5afcfcf639367f44$export$cfc9526388d5e621)(e, $d18313a77770ed23$var$state);
});
(0, $5be4820ecee02a5a$export$c19513be8e47ff73).addEventListener("click", ()=>(0, $4fc77922838a58e3$export$7849d704a310c6d1)($d18313a77770ed23$var$state));
(0, $5be4820ecee02a5a$export$69181d24bfc61261).addEventListener("click", ()=>(0, $4fc77922838a58e3$export$8a9e2a13fbf8faaf)($d18313a77770ed23$var$state));
document.querySelectorAll(".d-btn").forEach((item)=>item.addEventListener("click", (e)=>(0, $5afcfcf639367f44$export$cfc9526388d5e621)(e, $d18313a77770ed23$var$state)));


//# sourceMappingURL=index.c8910e60.js.map
